const calculateNewElementSize = (
  rowStart: number,
  rowEnd: number,
  countLast: boolean = false
) => {
  const elementsCount: number = rowEnd - rowStart + 1;
  const size = Math.trunc(12 / (elementsCount + (countLast ? 1 : 0)));

  return size === 0 ? 1 : size;
};

export default calculateNewElementSize;
